import React, { useEffect, useState } from "react";
import { Typography, Box, Backdrop, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import patientApi from "../../api/PatientApi";
import calculateAge from "../../utils/calculateAge";
import { colors } from "../../constants/constants";

const PatientDetails = ({ patient }) => {
  const navigate = useNavigate();
  const patientAPI = patientApi();
  const [patientData, setPatientData] = useState(null);
  const [loading, setLoading] = useState(false);

  async function handlePatientClick(patient) {
    setLoading(true);
    try {
      const patientDescriptionResponse = await patientAPI.fetchPatientInfoById(
        patient.patient_id
      );
      setPatientData(patientDescriptionResponse);
    } catch (error) {
      console.error("Error fetching patient data:", error);
    }
    setLoading(false);
  }

  useEffect(() => {
    handlePatientClick(patient);
  }, []);

  return (
    <>
     {loading ? (
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            display: "flex",
            marginTop:'50px',
            justifyContent: "center",
            alignItems: "center",
            color: '#fff',
            borderRadius: "8px"
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      ):
      
      <Box sx={{ background: "#141c28", borderRadius: 5, padding: 2, mb: 2 }}>
        <Box>
          <Typography fontSize={"1.2rem"} sx={{ fontWeight: "bolder" }}>
            {`${patientData?.first_name || ""} ${patientData?.last_name || ""}`}
          </Typography>
          <Box display={"flex"} gap={2}>
            <Typography variant="subtitle1" sx={{ color: colors.appTextGray }}>
              {`Gender: ${patientData?.gender || ""}`}
            </Typography>
            <Typography
              variant="body1"
              sx={{ padding: "3px", color: colors.appTextGray }}
            >
              {`Age : ${calculateAge(
                patientData?.date_of_birth.split("T")[0] 
              ) || ""} years`}
            </Typography>
          </Box>
        </Box>

        <Box my={"1rem"} gap={2} display="flex">
          <Box
            flex={1}
            sx={{
              background: colors.appChatWindowColor,
              borderRadius: 2,
              border: `1px solid ${colors.appLightBlue}`,
            }}
            padding="1rem"
          >
            <Typography paddingBottom="15px">Medications</Typography>
            <Typography fontSize={13} color={colors.appTextGray}>
              {patientData?.medications.map((med) => (
                <li key={med.medication_id}>
                  {med.medication.medication_name}
                </li>
              )) || ""}
            </Typography>
          </Box>

          <Box
            flex={1}
            sx={{
              background: colors.appChatWindowColor,
              borderRadius: 2,
              border: `1px solid ${colors.appLightBlue}`,
            }}
            padding="1rem"
          >
            <Typography paddingBottom="15px">Allergies</Typography>
            <Typography fontSize={13} color={colors.appTextGray}>
              {patientData?.allergies.map((allergy) => (
                <li key={allergy.allergy_id}>
                  {allergy.allergy.allergy_name}
                </li>
              )) || ""}
            </Typography>
          </Box>

          <Box
            flex={1}
            sx={{
              background: colors.appChatWindowColor,
              borderRadius: 2,
              border: `1px solid ${colors.appLightBlue}`,
            }}
            padding="1rem"
            marginRight={"20px"}
          >
            <Typography paddingBottom="15px">Condition Overview</Typography>
            <Typography fontSize={13} color={colors.appTextGray}>
              {patientData?.conditions.map((condition) => (
                <li key={condition.condition_id}>
                  {condition.condition.condition_name}
                </li>
              )) || ""}
            </Typography>
          </Box>
        </Box>

        <Box>
          <Typography paddingBottom="5px" fontWeight={'bolder'} color={colors.appTextGray}>
            Reason for Visit
          </Typography>
          <Typography fontSize={14} color={colors.appTextGray}>
            {patientData?.visit_reasons[0]?.reason || "No information related to this could be found."}
          </Typography>
        </Box>
      </Box>
}
    </>
  );
};

export default PatientDetails;
